import axios from 'axios';

const settings = window.APP_SETTINGS;

export const getExpert = () => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/experts`, {
		transformResponse: strData => {
			if (!strData) return;
			const data = JSON.parse(strData);
			return {
				email: data.email,
				firstName: data.firstName,
				lastName: data.lastName,
				company: data.company,
				address: data.address,
				city: data.city,
				stateId: data.stateId,
				zipCode: data.zipCode,
				phone: data.phone,
				fax: data.fax
			};
		}
	});
};

export const updateExpert = values => {
	const updates = {
		firstName: values.firstName,
		lastName: values.lastName,
		company: values.company,
		address: values.address,
		city: values.city,
		stateId: values.stateId,
		zipCode: values.zipCode,
		phone: values.phone,
		fax: values.fax
	};

	if (values.password) {
		updates.changePassword = {
			newPassword: values.password,
			confirmPassword: values.confirmPassword
		}
	}
	
	return axios.put(`${settings.EXPERT_API_BASE_URL}/experts`, updates);
};
